import NotificationComponent from './NotificationsSystemComponent'
export default NotificationComponent
